"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wizard = void 0;
const deployerClass_1 = require("./interface/deployerClass");
const constantsClass_1 = require("./interface/constantsClass");
const contractClass_1 = require("./interface/contractClass");
const utilsClass_1 = require("./interface/utilsClass");
const savETHPoolClass_1 = require("./interface/savETHPoolClass");
const feesAndMevPoolClass_1 = require("./interface/feesAndMevPoolClass");
const giantSavETHPoolClass_1 = require("./interface/giantSavETHPoolClass");
const giantFeesAndMevPoolClass_1 = require("./interface/giantFeesAndMevPoolClass");
const helperClass_1 = require("./interface/helperClass");
const zecClass_1 = require("./interface/zecClass");
class Wizard {
    constructor({ signerOrProvider, liquidStakingManagerAddress, savETHPoolAddress, feesAndMevPoolAddress, frenDelegationBribeVaultAddress }) {
        this.etherSigner = signerOrProvider;
        this.deployer = new deployerClass_1.DeployerSubPackage(this.etherSigner);
        this.utils = liquidStakingManagerAddress
            ? new utilsClass_1.UtilsSubPackage(this.etherSigner, liquidStakingManagerAddress, frenDelegationBribeVaultAddress)
            : undefined;
        this.savETHPool = savETHPoolAddress
            ? new savETHPoolClass_1.SavETHPoolSubPackage(this.etherSigner, savETHPoolAddress)
            : undefined;
        this.feesAndMevPool = feesAndMevPoolAddress
            ? new feesAndMevPoolClass_1.FeesAndMevPoolSubPackage(this.etherSigner, feesAndMevPoolAddress)
            : undefined;
        this.giantSavETHPool = new giantSavETHPoolClass_1.GiantSavETHPoolSubPackage(this.etherSigner);
        this.giantFeesAndMevPool = new giantFeesAndMevPoolClass_1.GiantFeesAndMevPoolSubPackage(this.etherSigner);
        this.helper = new helperClass_1.HelperSubPackage(this.etherSigner);
        this.contractInstance = new contractClass_1.ContractSubPackage(this.etherSigner);
        this.constants = new constantsClass_1.ConstantsSubPackage(this.etherSigner);
        this.zec = new zecClass_1.ZECSubPackage(this.etherSigner);
    }
}
exports.Wizard = Wizard;
